import React, { createContext, useState, useCallback } from 'react';
import Notification from './components/Notification';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState(null);

    const showNotification = useCallback((message, type = 'success', duration = 3000) => {
        setNotification({ message, type, duration });
    }, []);

    const closeNotification = () => {
        setNotification(null);
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            {notification && (
                <Notification 
                    message={notification.message} 
                    type={notification.type} 
                    duration={notification.duration} 
                    onClose={closeNotification} 
                />
            )}
        </NotificationContext.Provider>
    );
};

export default NotificationContext;